<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键字" name='name'>
      <a-input v-model:value="search.name" :style="{width:'300px'}" placeholder="请输入物流公司名称进行搜索" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数:${total} `" />
  
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getLibExpressList } from "@/api/order";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit:5,
    name: '',
  };
  export default {
    name: "Express",
    components: {},
    props: {
      selectList:{
        type:Array
      },
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1,
        selectList:[],
      });
      let columns = [
        {
          title: "物流公司名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "编号",
          dataIndex: "code",
          key: "code",
        },
        {
          title: "操作",
          key: "action",
          width:120,
          slots: { customRender: "action" }
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        e.select = !e.select
        emit("select", e);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getLibExpressList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
            if(props.selectList || props.selectList.length > 0){
              data.value.forEach(i=>{
                if( props.selectList.find(v=>i.id == v.id)){
                  i.select=true
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };

      onMounted(() => {
        initData(search.value)
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select
      };
    },
  };
</script>